import React from 'react';
import styled from 'styled-components';

import JsonLd from '../../components/jsonld';
import OfficeCard from '../../components/office-card';
import SEO from '../../components/seo';

import { AnimateIn, Container, Grid, GridItem, TitleSet } from '../../ui-components';

/**
 * Renders the SEO metatag and structured data elements
 *
 * @function renderSEO
 * 
 * @returns {JSX}
 */
const renderSEO = (CONTENT, slug) => {
  return (
    <>
      <SEO title={CONTENT.OFFICES__TITLE} description={CONTENT.OFFICES__SUBTITLE} slug={slug} />
      <JsonLd
        item={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: CONTENT.OFFICES__TITLE,
          alternateName: CONTENT.OFFICES__TITLE,
          description: CONTENT.OFFICES__SUBTITLE,
          abstract: CONTENT.OFFICES__SUBTITLE,
          headline: CONTENT.OFFICES__SUBTITLE,
          alternativeHeadline: CONTENT.OFFICES__SUBTITLE,
          inLanguage: 'en',
          url: `http://credera.com/${slug}`,
          isAccessibleForFree: true
        }}
      />
    </>
  );
};

/**
 * Renders the grid items for a set of locations
 *
 * @function renderLocationList
 * 
 * @param {array} locations
 * 
 * @returns {JSX}
 */
const renderLocationList = locations => {
  return locations.map(location => (
    <OfficeGridItem col={4} colxl={6} collg={6} colmd={12} key={location.locationName}>
      <OfficeCard office={location} />
    </OfficeGridItem>
  ));
};

/**
 * Renders the offices section
 *
 * @function renderOffices
 * 
 * @param {object} CONTENT
 * @param {object} offices
 * 
 * @returns {JSX}
 */
const renderOffices = (CONTENT, offices) => {
  return (
    <>
      <AnimateIn onScroll>
        <TitleSet
          title={CONTENT.OFFICES__TITLE}
          bodyText={CONTENT.OFFICES__SUBTITLE}
          isPageLevelTitleSet
          isLandingPageWidth
        />
      </AnimateIn>
      <OfficesContainer sectionContainer>
        <AnimateIn onScroll delay={300}>
          <Grid>{renderLocationList(offices)}</Grid>
        </AnimateIn>
      </OfficesContainer>
    </>
  );
};

const orderOfficesByGeo = (offices, geo) => {
  const officeGroups = offices.reduce((acc, office) => {
    acc[office.region === geo ? 0 : 1].push(office);
    return acc;
  }, [[], []]);
  
  const geoOffices = officeGroups[0];
  const otherOffices = officeGroups[1]; 
  const orderedOffices = geoOffices.concat(otherOffices);

  return orderedOffices;
}

const OfficesContainer = styled(Container)`
  padding-top: 0;
`;

const OfficeGridItem = styled(GridItem)`
  justify-content: center;
`;

export { renderOffices, renderSEO, orderOfficesByGeo };
